import Http from "../util/httpUtils"
import {
  ONLINE_HTTP,
  visitorFlow,
  visitorRecord,
  userProfile,
  userAssets,
} from "../constants/conf"

export default {
  /**
   * 客流趋势
   * @param id
   * @param date
   */
  getVisitorFlow: function(id, date) {
    if (visitorFlow[id]) {
      return new Promise(resolve => {
        resolve(visitorFlow[id])
      })
    }
    return Http.get(ONLINE_HTTP + "/api/v1/visitor_flow", { id, date })
  },
  /**
   * 到访分析
   * @param id
   * @param date
   */
  getVisitorRecord: function(id, date) {
    if (visitorRecord[id]) {
      return new Promise(resolve => {
        resolve(visitorRecord[id])
      })
    }
    return Http.get(ONLINE_HTTP + "/api/v1/visitor_record", { id, date })
  },
  /**
   * 用户基础画像
   * @param id
   * @param date
   * @param page
   * @param page_size
   */
  getUserProfile: function(id, date, page, page_size) {
    if (userProfile[id]) {
      return new Promise(resolve => {
        resolve(userProfile[id])
      })
    }
    return Http.get(ONLINE_HTTP + "/api/v1/portrait", {
      id,
      date,
      page,
      page_size,
    })
  },
  /**
   * 用户经济画像
   */
  getUserAssets: function(id, date) {
    return new Promise(resolve => {
      resolve(userAssets[id] || {})
    })
  },
  /**
   * 店铺排行
   * @param floor
   * @param date
   */
  getShopRank: function(floor, date) {
    return Http.get(ONLINE_HTTP + "/api/v1/shop_rank", { floor, date })
  },
  /**
   * 购买意愿
   * @param id
   * @param date
   * @param page
   * @param page_size
   * @param perc_filter
   */
  getPurchaseIntention: function(id, date, page, page_size, perc_filter) {
    return Http.get(ONLINE_HTTP + "/api/v1/purchase_intention", {
      id,
      date,
      page,
      page_size,
      perc_filter,
    })
  },

  /**
   * 店铺动线
   * @param id
   * @param date
   */
  getShopActive: function(id, date) {
    return Http.get(ONLINE_HTTP + "/api/v1/line", { id, date })
  },

  /**
   * 店铺相关
   * @param id
   * @param date
   */
  getShopRelevance: function(id, date) {
    return Http.get(ONLINE_HTTP + "/api/v1/relevance", { id, date })
  },
}
